import React from 'react'
import PropTypes from 'prop-types'

export default class ActiveLink extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
    activeStyle: PropTypes.any,
    inactiveStyle: PropTypes.any
  }

  handleClick = (e) => {
    const { onClick } = this.props
    
    e.preventDefault()
    onClick()
  }

  render() {
    const { show, children, inactiveStyle, activeStyle } = this.props

    if(show) {
      return (
        <a href="#" onClick={this.handleClick} style={activeStyle}>
          { children }
        </a>
      )
    }
    else {
      return <span style={inactiveStyle}>{ children }</span>
    }
  }
}
